import "./App.css";

const Loading = () => {
  return <p className="loading">Ładowanie danych...</p>;
};

export default Loading;
